export enum RecurrenceOptions {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}
